import { render, staticRenderFns } from "./ImagePreviewDialogue.vue?vue&type=template&id=4902d55c&scoped=true&"
import script from "./ImagePreviewDialogue.vue?vue&type=script&lang=ts&"
export * from "./ImagePreviewDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./ImagePreviewDialogue.vue?vue&type=style&index=0&id=4902d55c&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4902d55c",
  null
  
)

export default component.exports